import { impersonationControllerRevokeCurrentSession } from '../generated/kubb';
import { clearImpersonationSession } from './impersonation';

/** A revoke that never settles must not keep the operator inside the session. */
const REVOKE_TIMEOUT_MS = 5_000;

/**
 * Ends the impersonation session on the server as well, so the token is dead for
 * anyone holding a copy — clearing `sessionStorage` alone would only close this
 * tab's view of it. Best-effort: neither a failure nor a hang may keep the
 * operator in.
 *
 * Reloads rather than navigating so no impersonated data survives in memory.
 */
export const exitImpersonation = async (): Promise<void> => {
  try {
    await Promise.race([
      impersonationControllerRevokeCurrentSession(),
      new Promise(resolve => setTimeout(resolve, REVOKE_TIMEOUT_MS)),
    ]);
  } catch {
    // Already revoked, expired, or offline — leaving is still the right outcome.
  }
  clearImpersonationSession();
  window.location.replace('/');
};
